<template>
    <div>

      <div class="input-part">
        <div class="input-label">
          <span tkey="有效期">{{i18n.tkey("lang_expiration")}}</span>
        </div>

        <div style="display: flex;align-items: center;">
            <el-input
                v-model="dataObj.PromoStartDate"
                type="date"
                class="date-input"
                :placeholder="i18n.tkey('lang_start_date')"
            />
            <span> - </span>
            <el-input
                v-model="dataObj.PromoEndDate"
                type="date"
                class="date-input"
                :placeholder="i18n.tkey('lang_end_date')"
            />
        </div>
      </div>

      <div class="input-part">
          <div class="input-label">
            <span tkey="類型">{{i18n.tkey("lang_type")}}</span>
          </div>

          <div>
            <el-select
                v-model="dataObj.PromoStatus"
                :placeholder="i18n.tkey('lang_select_pls')"
                size="large"
                style=""
            >
                <el-option
                    :key="1"
                    :label="i18n.tkey('lang_coupons_amount')"
                    :value="1"
                />
                <el-option
                    :key="2"
                    :label="i18n.tkey('lang_coupons_discount')"
                    :value="2"
                />
            </el-select>
          </div>
      </div>


      <div class="input-part">
        <div class="input-label">
          <span v-if="dataObj.PromoStatus==1" tkey="優惠金額">{{i18n.tkey("lang_coupons_amount")}}:{{shopCompany.currcode}}</span>
          <span v-if="dataObj.PromoStatus==2" tkey="優惠折扣">{{i18n.tkey("lang_coupons_discount")}}%</span>
        </div>

        <div>
          <el-input
              v-if="dataObj.PromoStatus==1"
              type="number"
              v-model="dataObj.PromoCost"
              placeholder=""
              clearable
              min="0"
          />

          <el-input
              v-if="dataObj.PromoStatus==2"
              type="number"
              v-model="dataObj.PromoDiscount"
              placeholder=""
              clearable
              min="0"
          />
        </div>
      </div>

      <el-col :span="24">
        <el-collapse>
          <el-collapse-item :title="i18n.tkey('lang_Advanced_Setting')" >
            <el-row :gutter="20" style="margin: 0">
              <div class="input-part">
                <div class="input-label">
                  <span tkey="數量">{{i18n.tkey("lang_qty")}}({{i18n.tkey("lang_Nofilling_Norestrictions")}})</span>
                </div>

                <div>
                  <el-input
                      type="number"
                      v-model="dataObj.PromoQty"
                      placeholder=""
                      clearable
                      min="1"
                  />
                </div>
              </div>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-col>




        <div style="padding: 15px 0px">
            <el-button type="primary" @click="clickAddBtn" tkey="添加">{{i18n.tkey("lang_add")}}{{i18n.tkey("lang_discount_coupons")}}</el-button>
       </div>

    </div>
</template>

<script setup>
    import {inject, ref, onBeforeMount, onMounted} from "vue";
    import myUtil from "@/util/util";

    const props = defineProps(['editObj'])
    const emits = defineEmits(['clickAdd'])
    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const i18n = inject("i18n")
    const shopCompany = ref({})

    const dataObj = ref({
      ProductID:'',
      ProductName: 'coupons',
      ProductType: '',
      PromoStatus:1,//1為金額、2為比例
      PromoStartDate:myUtil.formatDate(new Date(), 'yyyy-MM-dd'),
      PromoEndDate:myUtil.formatDate(myUtil.addMonths(new Date(),3) , 'yyyy-MM-dd'),
      TypeID:'CdCash',
      PromoProductID:'',//綁定產品
      RequestAmount:0,//條件
      PromoCost:1,//折扣金額
      PromoQty:0,//折扣數量
      PromoDiscount:1//折扣比例
    })



    function clickAddBtn() {

      emits("clickAdd", dataObj.value)
    }



    onBeforeMount(() => {
      shopCompany.value = getShopCompanyObj()
    })

    onMounted(() => {
     // console.log(props.editObj)
      if (null != props.editObj){
        dataObj.value.CompanyCode =props.editObj.acccode
        dataObj.value.PromoProductID =props.editObj.productid
        dataObj.value.ProductType =props.editObj.bcatacode
        dataObj.value.ProductType2 =props.editObj.bcatacode2

      }
    })

</script>

<style scoped>
    .input-part {
        margin-bottom: 20px;
    }

    .input-label {
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 12px;
    }
</style>